"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BrokenLinkOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M20.1,16.32a5.49,5.49,0,0,1-4.42-2.21,1,1,0,1,1,1.6-1.19,3.53,3.53,0,0,0,4.93.7l4.38-3.29a3.52,3.52,0,0,0,.71-4.92,3.54,3.54,0,0,0-4.93-.71L19,7.46a1,1,0,1,1-1.28-1.54l3.38-2.79a5.51,5.51,0,0,1,8.8,5.17,5.42,5.42,0,0,1-2.15,3.63l-4.38,3.29A5.53,5.53,0,0,1,20.1,16.32Z"/><path d="M7.85,30a5.52,5.52,0,0,1-4.49-8.71l2.7-3.46a1,1,0,0,1,1.58,1.24L5,22.48A3.52,3.52,0,0,0,8.44,28a3.47,3.47,0,0,0,2.28-1.43l3.18-4.47a3.52,3.52,0,0,0-.83-4.9,1,1,0,1,1,1.16-1.63,5.52,5.52,0,0,1,1.3,7.69l-3.18,4.47A5.5,5.5,0,0,1,7.85,30Z"/><path d="M12,13a1,1,0,0,1-.71-.29L7.78,9.2A1,1,0,0,1,9.2,7.78l3.49,3.49a1,1,0,0,1,0,1.42A1,1,0,0,1,12,13Z"/><path d="M9.77,16a1.09,1.09,0,0,1-.26,0L4.74,14.69a1,1,0,1,1,.52-1.93L10,14a1,1,0,0,1,.7,1.23A1,1,0,0,1,9.77,16Z"/><path d="M15,10.77A1,1,0,0,1,14,10L12.76,5.26a1,1,0,1,1,1.93-.52L16,9.51a1,1,0,0,1-.71,1.22A.82.82,0,0,1,15,10.77Z"/>';
var BrokenLinkOutlineSVG = function BrokenLinkOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BrokenLinkOutlineSVG = BrokenLinkOutlineSVG;
BrokenLinkOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BrokenLinkOutlineSVG);
exports.default = _default;